import { render } from "./VoidReason.vue?vue&type=template&id=4bdadc10"
import script from "./VoidReason.vue?vue&type=script&lang=js"
export * from "./VoidReason.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__